export const FILMSTRIP_CAROUSEL_EVENTS = {
  SWIPE: 'filmstripCarousel.swipe',
};
